var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabSettingsIpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#36F6FF",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19H26.389M26.389 19C26.389 20.9598 25.611 22.8389 24.2252 24.2247C22.8394 25.6105 20.9598 26.389 19 26.389M26.389 19C26.389 17.0402 25.611 15.1601 24.2252 13.7743C22.8394 12.3885 20.9598 11.611 19 11.611M19 9.5V11.611M19 11.611C17.0403 11.611 15.1609 12.3885 13.7752 13.7742C12.3895 15.1599 11.611 17.0393 11.611 18.999C11.611 20.9587 12.3895 22.8381 13.7752 24.2238C15.1609 25.6095 17.0403 26.389 19 26.389M9.5 19H11.611M19 28.5V26.389",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23.2213C20.1197 23.2213 21.1936 22.7765 21.9854 21.9847C22.7772 21.193 23.222 20.1191 23.222 18.9993C23.222 17.8796 22.7772 16.8057 21.9854 16.0139C21.1936 15.2222 20.1197 14.7773 19 14.7773C17.8803 14.7773 16.8064 15.2222 16.0146 16.0139C15.2228 16.8057 14.778 17.8796 14.778 18.9993C14.778 20.1191 15.2228 21.193 16.0146 21.9847C16.8064 22.7765 17.8803 23.2213 19 23.2213Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabSettingsIpIcon);
export default __webpack_public_path__ + "static/media/tc_cab_settings_ip_icon.3cc3f6a00666f2eca377059abf217cdc.svg";
export { ForwardRef as ReactComponent };